// @ts-nocheck
const ErrorFallback = () => <div>Something went wrong.</div>;

export default ErrorFallback;
